<template>
  <div>

    <div>
      <v-form ref="form">
        <v-container>
          <v-layout wrap>

            <v-flex md2 sm12>
              <v-select :items="filterByItems" v-model="selected_filter_by"
                :label="$t('monitoring.declinedBookingsStats.filterBy')"></v-select>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label="$t('common.from')" v-model="from"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Day'">
              <choose-date clearable :label="$t('common.to')" v-model="to"></choose-date>
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Month'">
              <date-picker-multiple v-model="selected_month" />
            </v-flex>
            <v-flex md2 sm12 v-if="selected_filter_by == 'Year'">
              <v-select :items="years" item-text="Year" v-model="selected_year" :label="$t('monitoring.declinedBookingsStats.selectYear')"></v-select>
            </v-flex>

            <v-flex md1 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(false)" :loading="loading">{{ $t("monitoring.declinedBookingsStats.getData") }}</v-btn>
            </v-flex>
            <v-flex md1 sm12>
              <v-btn color="primary" dark class="mb-2 cbtn" @click="getData(true)" :loading="loading">{{ $t("monitoring.declinedBookingsStats.exportPdf") }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
    <div v-if="totals">
      <v-container>
        
        <v-layout wrap>
          <v-flex md2 sm12>
            <h3>{{ $t("monitoring.declinedBookingsStats.totals") }}</h3>
          </v-flex>
          <v-flex md2 sm12>
            {{ $t("monitoring.declinedBookingsStats.byCallCenterCount", { count: totals.user_count_total }) }}
          </v-flex>
          <v-flex md2 sm12>
            {{ $t("monitoring.declinedBookingsStats.byCustomerAppCount", { count: totals.passenger_count_total }) }}
          </v-flex>
          <v-flex md2 sm12>
            {{ $t("monitoring.declinedBookingsStats.totalCount", { count: totals.total_count_total }) }}
          </v-flex>

        </v-layout>
      </v-container>
    </div>
    <div>
      <v-data-table :headers="headers" :items="stats" :loading="loading" :pagination.sync="pagination">
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">{{ `${props.item.location_cluster_name}` }}</td>
            <td class="text-xs-left">{{ `${props.item.user_count}` }}</td>
            <td class="text-xs-left">{{ `${props.item.passenger_count}` }}</td>
            <td class="text-xs-left">{{ `${props.item.total_count}` }}</td>
          </tr>
        </template>
      </v-data-table>

    </div>

    <div v-if="showChart" class="trend-chart">
      <h2>{{ $t("monitoring.declinedBookingsStats.declinedBookingsChart") }}</h2>
      <div class="bar-chart-wrapper">
        <BarChart :chartdata="chartdata" :options="chartOptions" class="bar-chart" />
      </div>
    </div>

  </div>
</template>

<style lang="scss"></style>

<script>
import ChooseDate from "@/components/monaco/input/ChooseDate";
import DatePickerMultiple from "@/components/monaco/input/DatePickerMultiple";
import BarChart from "@/components/profile/captain/BookingsBarChart";

export default {
  name: "DeclinedBookingsStats",
  title() {
    return this.$t("monitoring.declinedBookingsStats.title");
  },
  components: { ChooseDate, DatePickerMultiple, BarChart },
  data() {
    return {
      filterBy: ["Day", "Month", "Year"],
      from: null,
      to: null,
      selectedYear: null,
      selected_filter_by: "Day",
      selected_day: null,
      selected_month: null,
      selected_year: null,
      custom_month: null,
      custom_year: null,
      reservation: true,
      instant: true,
      loading: false,
      years: [],
      stats: [],
      trend:[],
      chart_filter: null,
      totals: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "position_by_active",
        descending: false
      },
      defaultSortOptions: {
        sortBy: ['active_count'],
        sortDesc: [true]
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: function (value) {
                  if (value % 1 === 0) {
                    return value;
                  }
                },
              },
            },
          ],
        },
      }
    };
  },

  computed: {
    headers() {
      return [
        { text: this.$t("monitoring.declinedBookingsStats.city"), value: 'location_cluster_name', sortable: false },
        { text: this.$t("monitoring.declinedBookingsStats.byCallCenter"), value: 'user_count', sortable: false },
        { text: this.$t("monitoring.declinedBookingsStats.byCustomerApp"), value: 'passenger_count', sortable: false },
        { text: this.$t("monitoring.declinedBookingsStats.total"), value: 'total_count', sortable: false }
      ];
    },
    filterByItems() {
      return this.filterBy.map((value) => ({
        text: this.$t(`monitoring.declinedBookingsStats.filterByOptions.${value}`),
        value,
      }));
    },
    showChart() {
      return (
        (this.chart_filter === "Month" || this.chart_filter === "Year") &&
        this.trend &&
        this.trend.length > 0
      );
    },

    chartdata() {
      const labels = this.trend.map((item) => {
        // Yearly trend uses "YYYY-MM" (monthly buckets), monthly trend uses
        // "YYYY-MM-DD" (daily buckets).
        return this.chart_filter === "Year"
          ? moment(item.period, "YYYY-MM").format("MMM")
          : moment(item.period, "YYYY-MM-DD").format("DD");
      });
      return {
        labels: labels,
        datasets: [
          {
            backgroundColor: "#D71010",
             maxBarThickness: 15,
            // barPercentage: 0.5,
            // categoryPercentage: 0.6,
            data: this.trend.map((item) => item.count),
          },
        ],
      };
    },
  },
  watch: {

    selected_month(val) {
      if (val) {
        this.from = moment(val).startOf("month").format("YYYY-MM-DD");
        this.to = moment(val).endOf("month").format("YYYY-MM-DD");
      }

      //this.getData(false);
    },
    selected_year(val) {
      if (val) {
        this.from = moment(val, "YYYY").startOf("year").format("YYYY-MM-DD");
        this.to = moment(val, "YYYY").endOf("year").format("YYYY-MM-DD");
      }

      //  this.getData(false);
    },
    selected_filter_by(val) {
      this.selected_year = null;
      this.selected_month = null;
      this.selected_day = moment().format("YYYY-MM-DD");
      this.from = this.selected_day;
      this.to = this.selected_day;

    }

  },
  mounted() {
    const currentYear = new Date().getFullYear();
    this.years = Array.from({ length: 100 }, (v, i) => currentYear - i);
    this.selected_day = moment().format("YYYY-MM-DD");
    this.from = this.selected_day;
    this.to = this.selected_day;
  },
  methods: {

    getData(pdf) {

      this.loading = true;
      const params = new URLSearchParams();
      params.append("from", this.from);
      params.append("to", this.to);

      params.append("pdf", pdf ? 1 : 0);
      this.axios
        .get("declined_booking/stats", {
          responseType: pdf ? "blob" : "json",
          params: params,
        })
        .then((res) => {

          if (pdf == false) {
            console.log(res)
            this.stats = res.data.data.stats;
            this.totals = res.data.data.totals;
            this.trend = res.data.data.trend || [];
            this.chart_filter = this.selected_filter_by;
            console.log(this.stats)
          } else {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Declined orders report.pdf");
            document.body.appendChild(link);
            link.click();
          }
          this.loading = false;
        })
        .catch((err) => {
          window.getApp.$emit("SHOW_TOAST", err.response.data.message, "red");
          this.loading = false;
        });
    },
    addPercentage(val1, val2) {
      let percentage = (val2 ? (val1 * 100 / val2) : 0).toFixed(2);
      return val1 + "(" + percentage + "%)"

    }
  }



};
</script>
<style lang="scss" scoped>
.trend-chart {
  padding: 18px 25px;

  h2 {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .bar-chart-wrapper {
    position: relative;
    width: 100%;
    height: 400px;

    .bar-chart {
      width: 100%;
      height: 100%;
    }
  }
}

.options {
  width: 100%;
  float: left;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 2.5em;
  gap: 16px;

  // gap: 16px;
  .option {
    float: left;
    border: 1px solid #788e98;
    border-radius: 12px;
    overflow: hidden;
    min-width: 120px;

    .title {
      width: 100%;
      background: #ced3d4;
      padding: 12px 18px;
      float: left;
      color: #202731;
      font-size: 12pt !important;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 1px;

      .count {
        color: rgb(197, 203, 204);
        font-size: 8pt;
        padding: 4px;
        border-radius: 4px;
        background: rgb(97, 127, 133);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 85%;
        min-width: 24px;
        height: 24px;
      }
    }

    .percentage {
      width: 100%;
      padding: 0 12px;
      font-size: 18pt;
      color: #202731;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-weight: 700;

      .symbol {
        color: #788e98;
        font-size: 12pt;
        font-weight: 400;
        margin-left: 4px;
      }
    }
  }
}
</style>
